export { CookieBanner } from './CookieBanner.view'



// WEBPACK FOOTER //
// ./src/views/components/CookieBanner/index.ts